import { Typography } from "@novaescola/eva-react-v2/lib/Typography";
import { graphql } from "gatsby";
import Cookies from "js-cookie";
import React, { useCallback, useEffect, useState } from "react";
import ReactGA from "react-ga";

import { AccountApi } from "../api/account/account.api";
import Layout from "../components/Layout";
import Article from "../components/content-page/Article";
import RelatedContent from "../components/content-page/RelatedContent";
import ActionsButtons from "../components/general/ActionsButtons";
import ContentBreadcrumb from "../components/general/ContentBreadcrumb";
import ShareButtons from "../components/general/ShareButtons";
import BreadcrumbClassifications from "../components/recomposition-page/BreadcrumbClassifications";
import { isBrowser } from "../data/utils";
import PartnerMPBLogo from "../images/recomposition-page/partner-mpb-logo.png";
import PartnerReunaLogo from "../images/recomposition-page/partner-reuna-logo.png";

if (isBrowser()) {
  ReactGA.initialize("UA-26936412-2");
}

export function Head({ data: { content } }) {
  const title = content.title;
  const description = content.seoDescription;
  const image = content.thumbnailImage || content.featuredImage;
  
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={`https://novaescola.org.br${content.url}`} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="pt_BR" />
      <meta property="og:site_name" content="Nova Escola" />
      <link rel="manifest" href="/manifest.json" />
    </>
  );
}

const RecompositionPage = ({ data }) => {
  const [isClient, setIsClient] = useState(false)
  const [hasAlert, setHasAlert] = useState(false);
  const [showAlert, setShowAlert] = useState(true);

  useEffect(() => {
    setIsClient(true)
  }, [])
  const tags = data.content.tags;
  const categories = data.content.categories;
  let linkDonwloadAllContents = '';
  let txtBtnDonload = '';

  let tagsOfContent = []
  let subjectsOfContent = []

  tags.map((e) => {
    tagsOfContent.push(e.tag)
  })

  categories.map((e) => {
    subjectsOfContent.push(e.name)
  });

  if (
    tagsOfContent.includes('1º ano') && (subjectsOfContent.includes('Língua Portuguesa') || subjectsOfContent.includes('Matemática')) ||
    tagsOfContent.includes('2º ano') && (subjectsOfContent.includes('Língua Portuguesa') || subjectsOfContent.includes('Matemática')) ||
    tagsOfContent.includes('3º ano') && (subjectsOfContent.includes('Língua Portuguesa') || subjectsOfContent.includes('Matemática')) ||
    tagsOfContent.includes('4º ano') && (subjectsOfContent.includes('Língua Portuguesa') || subjectsOfContent.includes('Matemática')) ||
    tagsOfContent.includes('5º ano') && (subjectsOfContent.includes('Língua Portuguesa') || subjectsOfContent.includes('Matemática'))) {
    linkDonwloadAllContents = 'https://observatorio.movimentopelabase.org.br/wp-content/uploads/2023/02/caderno-fichas-dos-professores-lp-e-mt-1o-ao-5o-ano.pdf';
    txtBtnDonload = 'matemática e língua portuguesa';
  } else if (
    tagsOfContent.includes('6º ano') && subjectsOfContent.includes('Matemática') ||
    tagsOfContent.includes('7º ano') && subjectsOfContent.includes('Matemática') ||
    tagsOfContent.includes('8º ano') && subjectsOfContent.includes('Matemática') ||
    tagsOfContent.includes('9º ano') && subjectsOfContent.includes('Matemática')) {
    linkDonwloadAllContents = 'https://observatorio.movimentopelabase.org.br/wp-content/uploads/2023/02/caderno-fichas-dos-professores-matematica-6o-ao-9o-ano.pdf';
    txtBtnDonload = 'matemática'
  } else if (
    tagsOfContent.includes('6º ano') && subjectsOfContent.includes('Língua Portuguesa') ||
    tagsOfContent.includes('7º ano') && subjectsOfContent.includes('Língua Portuguesa') ||
    tagsOfContent.includes('8º ano') && subjectsOfContent.includes('Língua Portuguesa') ||
    tagsOfContent.includes('9º ano') && subjectsOfContent.includes('Língua Portuguesa')) {
    linkDonwloadAllContents = 'https://observatorio.movimentopelabase.org.br/wp-content/uploads/2023/02/caderno-fichas-dos-professores-lingua-portuguesa-6o-ao-9o-ano-1.pdf';
    txtBtnDonload = 'língua portuguesa';
  }

  useEffect(() => {
    if (isBrowser()) {
      Cookies.set("ane_redirect", window.location.href, {
        domain: ".novaescola.org.br",
      });
    }
  });

  const authKeyName = "aneAuthUser";

  const [user, setUser] = useState({
    permissions: [],
    type: "anonimo",
    logged: false,
  });

  const [loggedIn, setLoggedIn] = useState(false);

  const getAuthUser = () =>
    isBrowser() && window.localStorage.getItem(authKeyName)
      ? JSON.parse(window.localStorage.getItem(authKeyName))
      : null;

  const setAuthUser = (user) =>
    window.localStorage.setItem(authKeyName, JSON.stringify(user));

  const fetchUser = async () => {
    const bearer = Cookies.get("Bearer");

    if (!bearer) {
      return null;
    }

    return AccountApi.getProfile(bearer);
  };

  const checkAuthUser = useCallback(async () => {
    let authUser = getAuthUser();

    if (authUser) {
      setUser(authUser);
      setLoggedIn(true);
    }

    try {
      authUser = await fetchUser();

      if (!authUser) {
        throw new Error("user not found");
      }

      setUser(authUser);
      setAuthUser(authUser);
      setLoggedIn(true);
    } catch (err) {
      setUser({
        permissions: [],
        type: "anonimo",
        logged: false,
      });
      setLoggedIn(false);
      setAuthUser(null);
    }
  }, []);

  useEffect(() => {
    checkAuthUser();
  }, [checkAuthUser]);

  const getUserDataToDataLayer = () => {

		const ocupacaoMap = {
			'PROFESSOR': 0,
			'OUTRA': 1,
			'ESTUDANTE': 2,
			'DIRETOR': 3,
			'COORDENADOR_PEDAGOGICO': 4,
			'P_M_R_POR_ALUNO': 5,
			'SECRETARIO_EDUCACAO': 6,
			'ESTAGIARIO': 7,
			'ORIENTADOR_EDUCACIONAL': 8,
			'AUXILIAR_CLASSE': 9,
			'TECNICO_SECRETARIA': 10,
			'SUB_SECRETARIO_EDUCACAO': 11
		};
		
		const disciplinaMap = {
			'CIENCIAS': 0,
			'FISICA': 1,
			'LINGUA_PORTUGUESA': 2,
			'HISTORIA': 3,
			'FILOSOFIA': 4,
			'SOCIOLOGIA': 5,
			'MATEMATICA': 6,
			'GEOGRAFIA': 7,
			'ARTE': 8,
			'EDUCACAO_FISICA': 9,
			'LINGUA_ESTRANGEIRA': 10,
			'QUIMICA': 11,
			'BIOLOGIA': 12,
			'OUTRO': 13,
			'POLIVALENTE': 14,
			'PROFESSOR_REGENTE': 15,
			'ENSINO_RELIGIOSO': 16
		};
		
		const etapasMap = {
			'ENSINO_MEDIO': 0,
			'ENSINO_FUNDAMENTAL_ANOS_INICIAIS': 1,
			'ENSINO_FUNDAMENTAL_ANOS_FINAIS': 2,
			'EJA': 3,
			'ENSINO_SUPERIOR': 4,
			'EDUCACAO_INFANTIL_PRE_ESCOLA': 5,
			'EDUCACAO_INFANTIL_CRECHE': 6,
			'OUTRO': 7,
			'PRE_VESTIBULAR': 8
		};
		
		const localTrabalhoMap = {
			'OUTRO': 0,
			'REDE_PRIVADA': 1,
			'REDE_PUBLICA_ESTADUAL': 2,
			'REDE_PUBLICA_MUNICIPAL': 3,
			'REDE_PUBLICA_FEDERAL': 4
		};
	
		const moreInfoData = {

			send: async function () {

				window.dataLayer = window.dataLayer || [];
				try {
					const bearer = Cookies.get('Bearer');
					const userData = await AccountApi.getUserData(bearer);
					window.dataLayer.push({
											'event': 'user_data',
											'user_id': userData.id,
											'user_logged': 1,
											'user_name': userData.nome,
											'user_email': userData.email,
											'user_phone': userData.telefone,
											'user_occupation': [ocupacaoMap[userData.ocupacao]],
											'user_discipline': userData.disciplinas.map(function (disciplina) {return disciplinaMap[disciplina.disciplinas]}),
											'user_stage' : userData.etapas.map(function (etapa){ return etapasMap[etapa.etapas] }),
											'user_network': userData.locaisTrabalho.map( function(local){ return localTrabalhoMap[local.localTrabalho]})
									});

				} catch (error) {
					// datalayer sem login
					window.dataLayer.push({
						'event': 'user_data',
						'user_logged': 0
					});
				}
			},
		};
		moreInfoData.send();
	};

  useEffect(() => {
    getUserDataToDataLayer();
  }, []);

  return isClient && (
    <Layout
      user={user}
      loggedIn={loggedIn}
      headerClass="padding-header"
      url={data.content.url}
      isOpenContent={data.content.isOpenContent}
      setHasAlert={setHasAlert}
      hasAlert={hasAlert}
      showAlert={showAlert}
      setShowAlert={setShowAlert}
    >
      <div className={`container recomposition ${(hasAlert && showAlert) ? "with-alert" : "" }`}>
        <div className="row">
          <section className="padding-left col-xl-11 col-lg-11 col-md-12 col-sm-12">
            {data.content.partners.map((partner, index) => (
              <div key={`partner${partner.name + index}`}>
                <Typography variant="body" size={3} asChild className="eva-margin-bottom-1">
                  <p>{partner.presentationText}</p>
                </Typography>
                <div className="partner-image" key={index}>
                  <a href={partner.url} target="_blank" rel="noreferrer">
                    <img
                      src={partner.featuredImage}
                      alt={partner.name}
                      loading="lazy"
                    />
                  </a>
                </div>
              </div>
            ))}

            <ContentBreadcrumb data={data} />

            <div className="row presented-by fd-column">
              <Typography variant="body" size={3} asChild className="col eva-mb-03">
                <p className="eva-text-uppercase">Apresentado poaaar</p>
              </Typography>
              <div className="col eva-mb-05 eva-pb-01">
                <img alt="Logotipo parceiro Movimento Pela Base" src={PartnerMPBLogo} className="eva-mr-06" />
                <img alt="Logotipo parceiro Reúna" src={PartnerReunaLogo} />
              </div>
            </div>

            <BreadcrumbClassifications data={data} />

            <div className="row">


              <article className="col-xl-8  col-lg-8  col-md-12 col-sm-12">
                <Typography variant="title" size={4} asChild className="eva-mb-03">
                  <h1>{data.content.title}</h1>
                </Typography>

                {
                  linkDonwloadAllContents && (
                    <div>
                      <a
                        href={linkDonwloadAllContents} target={'blank'}
                        data-track="PANE: Click - Fichas de recomposição - botão BAIXAR PDF com todas as fichas"
                        onClick={() => {
                          ReactGA.event({
                            action: "Click",
                            category: "PANE",
                            label: "Fichas de recomposição - botão BAIXAR PDF com todas as fichas",
                          });

                          const contentId = data.content.url.split('/')[2];
                          window.dataLayer = window.dataLayer || [];
                          window.dataLayer.push({
                            'event': 'download',
                            'label': 'pdf',
                            'item_id': contentId,
                            'item_name': data.content.title,
                            'item_category': 'recomposição'
                          });
                        }}
                      >
                        <button className="eva-btn-outline eva-btn-medium eva-mb-05 eva-mt-05">
                          <i className="far fa-download icon-left"></i> Baixar todas as fichas de {txtBtnDonload}
                        </button>
                      </a>
                    </div>)
                }
                <Typography variant="body" size={1} asChild className="eva-mb-01">
                  <h2>{data.content.excerpt}</h2>
                </Typography>
              </article>

              <aside className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
                <ActionsButtons
                  url={
                    !loggedIn
                      ? `/entrar?voltar=${data.content.url}`
                      : data.content.pdfLink
                  }
                  isPDFLink={loggedIn}
                />
              </aside>
            </div>

            <div className="row">
              <article className="col-xl-8 col-lg-8 col-md-12 col-sm-12">

                <Article data={data} loggedIn={loggedIn} />
              </article>

              <aside className="aside col-xl-4 col-lg-4 col-md-3 col-sm-12 d-flex fd-column">
                <div className="aside-share">
                  <Typography variant="body" size={2} asChild className="eva-mb-01">
                    <p>Compartilhe esse conteúdo:</p>
                  </Typography>
                  <ShareButtons data={data} />
                </div>
                <RelatedContent contents={data.content.related} />
              </aside>
            </div>
          </section>
        </div>
      </div>
    </Layout>
  );
};

export const query = graphql`
  query ($id: String) {
    content(id: { eq: $id }) {
      categories {
        category
        name
      }
      title
      featuredImage
      thumbnailImage
      isOpenContent
      excerpt
      publishedAt
      url
      seoDescription
      authors {
        id
        author
        uri
      }
      content
      tags {
        id
        tag
        uri
      }
      pdfLink
      related {
        id
        title
        url
        featuredImage
        external
      }
      partners {
        presentationText
        name
        url
        featuredImage
      }
    }
    allContentMostViewed(sort: { rankPosition: ASC }) {
      nodes {
        path
        rankPosition
        title
      }
    }
    allContentNewest {
      nodes {
        header
        featuredImage
        excerpt
        title
        url
      }
    }
  }
`;

export default RecompositionPage;
